import { decode as base64Decode } from 'js-base64';

export const jsonBase64Decode = <T>(data: string, defaultValue?: T): T => {
  if ((data || '').trim().length === 0) return defaultValue as T;

  let base64 = data.replaceAll('_', '/').replaceAll('-', '+');
  switch (data.length % 4) {
    case 2:
      base64 += '==';
      break;
    case 3:
      base64 += '=';
      break;
    default:
      break;
  }

  const json = base64Decode(base64);

  return JSON.parse(json ?? '{}') as T;
};
